export default {
    // REACT_APP_* variables are set in .env files and are accessible via process.env.
    // npm build runs production build, which uses .env.production
    baseUrl: process.env.REACT_APP_ADMIN_APIBASEURL,
    scopes: process.env.REACT_APP_ADMIN_SCOPES.split(';'),
}